import { Link } from 'react-router'
import { ArrowRight, Handshake, Images } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'

function DiscoverCard({ to, kicker, title, text, cta, icon: Icon, tone }) {
  const isDark = tone === 'dark'

  return (
    <Link
      to={to}
      className={`group relative flex h-full flex-col overflow-hidden rounded-3xl border p-6 shadow-sm transition-all duration-200 sm:p-7 ${
        isDark
          ? 'border-white/10 bg-gradient-to-br from-[#1a472a] via-[#2d6640] to-[#4a7c2a] text-white hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(26,71,42,0.28)]'
          : 'border-ng-dark/10 bg-white text-ng-dark hover:-translate-y-1 hover:border-ng-mid/30 hover:shadow-[0_18px_50px_rgba(26,71,42,0.12)]'
      }`}
    >
      <div
        className={`mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl ${
          isDark ? 'bg-white/15 text-white' : 'bg-ng-dark/5 text-ng-mid'
        }`}
      >
        <Icon className="h-6 w-6" aria-hidden="true" />
      </div>

      <span
        className={`text-xs font-semibold uppercase tracking-[0.18em] ${
          isDark ? 'text-white/70' : 'text-ng-brown'
        }`}
      >
        {kicker}
      </span>
      <h3 className={`font-display mt-2 text-2xl font-bold sm:text-3xl ${isDark ? 'text-white' : 'text-ng-dark'}`}>
        {title}
      </h3>
      <p className={`mt-3 flex-1 text-sm leading-relaxed sm:text-base ${isDark ? 'text-white/78' : 'text-ng-dark/70'}`}>
        {text}
      </p>

      <span
        className={`mt-6 inline-flex items-center gap-2 self-start text-sm font-semibold transition-colors ${
          isDark
            ? 'text-ng-gold group-hover:text-white'
            : 'text-ng-mid group-hover:text-ng-dark'
        }`}
      >
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </span>
    </Link>
  )
}

export default function Discover() {
  const { t } = useLanguage()

  return (
    <section id="discover" className="py-14 lg:py-20 bg-ng-beige">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 max-w-3xl sm:mb-10">
          <span className="text-sm font-medium uppercase tracking-wider text-ng-brown">
            {t('discoverSection.kicker')}
          </span>
          <h2 className="font-display mt-2 text-3xl font-bold text-ng-dark sm:text-4xl lg:text-5xl">
            {t('discoverSection.title')}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-ng-dark/70 sm:text-lg">
            {t('discoverSection.lead')}
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          <DiscoverCard
            to="/media"
            tone="dark"
            icon={Images}
            kicker={t('discoverSection.mediaKicker')}
            title={t('discoverSection.mediaTitle')}
            text={t('discoverSection.mediaText')}
            cta={t('discoverSection.mediaCta')}
          />
          <DiscoverCard
            to="/partenaires"
            tone="light"
            icon={Handshake}
            kicker={t('discoverSection.partnersKicker')}
            title={t('discoverSection.partnersTitle')}
            text={t('discoverSection.partnersText')}
            cta={t('discoverSection.partnersCta')}
          />
        </div>
      </div>
    </section>
  )
}
